import React from 'react';
import clsx from 'clsx';
import PageHeader from 'components/common/general/layouts/PageHeader';
import NotificationSettings from 'components/notification-settings';
import { createStyles } from '../../globalStyles';

const NotificationSettingsPage = (): JSX.Element => {
  const classes = createStyles();

  return (
    <div className={clsx(classes.pageWrapper, classes.simplePageWrapper)}>
      <PageHeader
        title="Manage Email Notifications"
        subtitle="The following email notifications can be turned off or on at any time"
      />
      <NotificationSettings />
    </div>
  );
};

export default NotificationSettingsPage;
